import { BalanceResponse } from '@/types/service-response'

export class Balance {
  private constructor (
    readonly id: number | null,
    readonly billingPeriod: string,
    readonly calculatedOn: string,
    readonly timeBalance: string,
    readonly present : string,
    readonly thatNight: string,
    readonly agrz: string,
    readonly timeBalancePreviousPeriod: string,
    readonly vacationPreviousPeriod: string,
    readonly vacationEntitlement: string,
    readonly agrzPreviousPeriod: string
  ) {}

  static createEmpty (): Balance {
    return new Balance(
      null,
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      ""
    )
  }

  static createFromResponse (responseData: BalanceResponse): Balance {
    return new Balance(
      responseData.ID,
      responseData.PER_PERIODE,
      responseData.PER_KALKULIERT,
      responseData.PER_SALDO,
      responseData.PER_ANWESEND,
      responseData.PER_NACHT,
      responseData.PER_AGRZ_SALDO,
      responseData.PER_SALDO_VOR,
      responseData.PER_FERIEN_VOR,
      responseData.PER_FERIEN_ANSPR,
      responseData.PER_AGRZ_VOR
    )
  }
}
